export default from './stripIndentTransformer';
